import { render, staticRenderFns } from "./FacultyListView.vue?vue&type=template&id=adf820b8"
import script from "./FacultyListView.vue?vue&type=script&lang=js"
export * from "./FacultyListView.vue?vue&type=script&lang=js"
import style0 from "./FacultyListView.vue?vue&type=style&index=0&id=adf820b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports